import {setCookie} from '/src/js/custom/cookies';
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';

//Set contact bar fixed when reaches to of the screen
var heroDetail = document.querySelector('.block_hero_detail');
var stickyButtons = document.querySelector('.sticky-buttons-course');
var lastScrollTop = 0;
var sidebar = document.querySelector('.course-sidebar__inner');

//Sticky sidebar
gsap.registerPlugin(ScrollTrigger);

ScrollTrigger.matchMedia({
    // desktop
    '(min-width: 1024px)': function () {
        var tl = gsap.timeline({
            scrollTrigger: {
                trigger: heroDetail,
                start: 'top top+=150',
                endTrigger: '.block_tabs_text',
                end: 'top top+=184',
                pin: sidebar,
                pinSpacing: false,
            }
        });
    }
});

export function fixedCourseButtons() {
    if (heroDetail && stickyButtons) {
        var heroDetailInner = heroDetail.getBoundingClientRect();
        var st = window.pageYOffset || document.documentElement.scrollTop;

        if (window.innerWidth < 1024) {
            if (heroDetailInner.bottom < 44) {
                stickyButtons.classList.add('is-sticky');
            } else {
                stickyButtons.classList.remove('is-sticky');
            }
        } else {
            if (st > lastScrollTop) {
                if (heroDetailInner.bottom < 61) {
                    stickyButtons.classList.add('is-sticky');
                } else {
                    stickyButtons.classList.remove('is-sticky');
                }
            } else {
                if (heroDetailInner.bottom < 136) {
                    stickyButtons.classList.add('is-sticky');
                } else {
                    stickyButtons.classList.remove('is-sticky');
                }
            }
        }

        lastScrollTop = st <= 0 ? 0 : st;
    }
}

let jsDataLink = document.querySelectorAll('.js-datalink');
let courseButton = document.querySelector('#signUpCourse');
let planACourceButton = document.querySelector('#planACourse');

jsDataLink.forEach(function (el) {
    el.addEventListener('click', function () {
        jsDataLink.forEach(function (item) {
            item.classList.remove('js-active');
        });

        this.classList.add('js-active');
        courseButton.classList.remove('disabled');
        courseButton.href = this.dataset.link;

        if(planACourceButton){
            planACourceButton.classList.remove('disabled');
            planACourceButton.href = this.dataset.planning;
        }
    });
});

let jsCategories = document.querySelectorAll('.js-infolink');
let informationButton = document.querySelector('#signUpInfo');

jsCategories.forEach(function (el) {
    el.addEventListener('click', function () {
        jsCategories.forEach(function (item) {
            item.classList.remove('js-active');
        });

        this.classList.add('js-active');
        informationButton.classList.remove('disabled');
        informationButton.href = this.dataset.link;
    });
});

